import React from "react";
import { getCookie } from '../util/cookie';

//报错日志
export let errorLog = (api, params, result, err, custom) => {
    //设置参数
    let obj = {};

    //vid
    obj.vid = getCookie('vid') || '';
    //唯一号
    obj.guid = React.$guid || '';
    //错误信息
    obj.message = err;
    //页面相关地址
    obj.url = {};
    //当前页面地址
    obj.url.u1 = window.location.href;
    //上一个页面地址
    obj.url.u2 = document.referrer || '';
    //数据接口地址
    obj.url.u3 = api || '';
    //请求数据接口所带的参数
    obj.params = params || {};
    //请求数据接口所返回的错误数据
    obj.result = result || {};
    //当地时间
    obj.localTime = new Date().getTime();
    //自定义错误信息
    obj.custom = custom || {};

    //发送日志
    let logImg = new Image();
    logImg.onload =function(){};
    logImg.src = 'https://app.dhgate.com/mobileApiWeb/biz-FeedBack-log.do?client=pc&language='+React.$lang+'&pageType=cart'+'&v='+encodeURIComponent(JSON.stringify(obj));
}